import Locations from "./locationSelector";

export default Locations;
